/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { Question } from '@src/app/model/ballot';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';


@Injectable({
  providedIn: 'root'
})
export class QuestionService extends AbstractHttpService {
  protected http = inject(HttpClient);
  protected messageService = inject(MessageService);

  protected get baseUrl() {
    return this.getAjaxPath('social/questions');
  }

  protected cache: Question[];
  protected typeString = 'Question';

}
